import { c as _c } from "react/compiler-runtime";
import { type ItemFinish, ItemOrientation } from "@sticker-giant/sg-frontend-common";
import { trackFinishSelected } from "@/lib/analytics/segment";
import { useProduct } from "@/queries/useProduct";
import { usePdpStore } from "@/stores/usePdpStore";
import OptionRadioField from "./OptionRadioField";
import { useProductBuilderContext } from "./ProductBuilderContext";
import { useProductMicrocopy } from "./useProductMicrocopy";
import { useFieldErrorId } from "./ValidationError";
export default function Finish() {
  const $ = _c(18);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin
  } = useProduct(product.sku);
  const selectedFinish = usePdpStore(_temp);
  const selectFinish = usePdpStore(_temp2);
  const setOrientation = usePdpStore(_temp3);
  const clearValidationError = usePdpStore(_temp4);
  const finishErrorId = useFieldErrorId("finish");
  const finishControlIdBase = `finish-${product.sku}`;
  const finishLabelId = `${finishControlIdBase}-label`;
  const finishHelpDialogId = `${finishControlIdBase}-help-dialog`;
  const microcopyFields = useProductMicrocopy();
  const finishHelper = microcopyFields?.finishHelper;
  const finishLabel = microcopyFields?.finishLabel ?? "Finish";
  const finishValue = selectedFinish ?? productAdmin?.defaultFinishing;
  if ((productAdmin?.finishingOptions.length ?? 0) <= 1) {
    return null;
  }
  let t0;
  if ($[0] !== clearValidationError || $[1] !== productAdmin?.defaultFinishing || $[2] !== productAdmin?.finishingOptions || $[3] !== selectFinish || $[4] !== setOrientation) {
    t0 = value => {
      const finish = value as ItemFinish;
      const finishOption = productAdmin?.finishingOptions.find(option => option.sku === finish);
      selectFinish(finish, productAdmin?.defaultFinishing);
      setOrientation(finishOption?.allowsOrientation ? undefined : ItemOrientation.NPR);
      clearValidationError("finish");
      trackFinishSelected(finish);
    };
    $[0] = clearValidationError;
    $[1] = productAdmin?.defaultFinishing;
    $[2] = productAdmin?.finishingOptions;
    $[3] = selectFinish;
    $[4] = setOrientation;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== productAdmin?.finishingOptions) {
    t1 = productAdmin?.finishingOptions ?? [];
    $[6] = productAdmin?.finishingOptions;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== finishControlIdBase || $[9] !== finishErrorId || $[10] !== finishHelpDialogId || $[11] !== finishHelper || $[12] !== finishLabel || $[13] !== finishLabelId || $[14] !== finishValue || $[15] !== t0 || $[16] !== t1) {
    t2 = <OptionRadioField field="finish" label={finishLabel} helper={finishHelper} controlIdBase={finishControlIdBase} labelId={finishLabelId} helpDialogId={finishHelpDialogId} errorId={finishErrorId} value={finishValue} onValueChange={t0} options={t1} />;
    $[8] = finishControlIdBase;
    $[9] = finishErrorId;
    $[10] = finishHelpDialogId;
    $[11] = finishHelper;
    $[12] = finishLabel;
    $[13] = finishLabelId;
    $[14] = finishValue;
    $[15] = t0;
    $[16] = t1;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  return t2;
}
function _temp4(state_2) {
  return state_2.clearValidationError;
}
function _temp3(state_1) {
  return state_1.setOrientation;
}
function _temp2(state_0) {
  return state_0.selectFinish;
}
function _temp(state) {
  return state.finish;
}